import { config } from '@/config/env';
import { puerto as identidad } from '../identidad/elPuerto';
import { AdaptadorDatosHttp } from './AdaptadorDatosHttp';
import { AdaptadorDatosLocal } from './AdaptadorDatosLocal';
import type { PuertoDeDatos } from './puerto';

/**
 * El único archivo del repo que nombra un adaptador de datos.
 *
 * Hermano de `identidad/elPuerto.ts`, con la misma regla y la misma prueba
 * detrás: `identidad/soloElPuerto.test.ts` recorre `src/` y falla si cualquier
 * otro archivo nombra `AdaptadorDatosHttp` o `AdaptadorDatosLocal`.
 *
 * Y se elige con **la misma condición** que el de identidad, no con otra: si
 * hay `capitalApiUrl`, los dos son de verdad; si no, los dos son de mentira.
 * Cruzarlos —login real y cifras simuladas, o al revés— daría una pantalla que
 * miente sobre la mitad de lo que enseña, y el aviso de simulación no sabría
 * cuál de las dos anunciar.
 *
 * El token no se pasa como valor: se pasa **la forma de pedirlo**. Así una
 * sesión renovada o cerrada se nota sin reconstruir nada.
 */
export const puertoDeDatos: PuertoDeDatos = config.capitalApiUrl
  ? new AdaptadorDatosHttp(config.capitalApiUrl, () => identidad.credencial())
  : new AdaptadorDatosLocal();
